<template>
  <div>
    <lottie-vue-player
      src="/animations/file-loading.json"
      loop
      autoplay
      style="width: 100%; height: 250px"
    >
    </lottie-vue-player>
  </div>
</template>

<script>
export default {};
</script>
